import ProviderInvoicePaymentFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ProviderInvoicePaymentApi, ProviderInvoicePaymentDataType } from "@/api/ProviderInvoicePaymentApi";
import { useRef } from "react";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { ProviderInvoicePaymentFormData, ProviderInvoicePaymentRelatedAttributes } from "@/formTypes/ProviderInvoicePaymentDataType";

type ProviderInvoicePaymentFormProps = {
  id?: string;
  providerInvoice?: ProviderInvoiceDataType;
  currencyId?: string;
  formId: string,
  saveRedirectUrl: string
}

const ProviderInvoicePaymentForm = (props: ProviderInvoicePaymentFormProps) => {
  const { providerInvoice } = props;
  const formRef = useRef<DynamicFormRef>(null);

  if (providerInvoice?.currencyId) {
    CurrencyIdPubSub.publish({ currencyId: providerInvoice?.currencyId, forceUpload: false })
  }

  return (
    <GenericForm<ProviderInvoicePaymentFormData, ProviderInvoicePaymentDataType>
      id={props.id}
      ref={formRef}
      formId={props.formId}
      defaultData={{
        providerInvoiceId: props.providerInvoice?.id,
        currencyId: `${props.providerInvoice?.currencyId}`,
        exchange_rate: props.providerInvoice?.exchange_rate
      }}
      saveRedirectUrl={props.saveRedirectUrl}
      modelRelativeObjects={ProviderInvoicePaymentRelatedAttributes}
      formConfig={ProviderInvoicePaymentFormConfig}
      getById={(...arg) => ProviderInvoicePaymentApi.get(...arg)}
      createFn={(...arg) => ProviderInvoicePaymentApi.create(...arg)}
      updateFn={(...arg) => ProviderInvoicePaymentApi.update(...arg)}
      successMessage="El abono ha sido agregada correctamente a la Factura del Provedor"
      errorMessage="No fue posible almacenar la informacion del abono a la Factura del Provedor"
    />
  )
}

export default ProviderInvoicePaymentForm;